var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"toc"}},[_c('div',{attrs:{"id":"toc-content"}},[_c('ul',_vm._l((_vm.items),function(li){return _c('li',{key:li.text},[_c('b-link',{attrs:{"href":'#' + li.id}},[_vm._v(_vm._s(li.text))])],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }